import { defineStore } from 'pinia';
import { computed, ref } from 'vue';

export const useServerBlockStore = defineStore('serverBlock', () => {
    const isBlocked = ref<boolean>(false);
    const blockReason = ref<string | null>(null);

    const reason = computed(() => blockReason.value);

    const setBlocked = (reason: string) => {
        isBlocked.value = true;
        blockReason.value = reason;
    };

    const clearBlock = () => {
        isBlocked.value = false;
        blockReason.value = null;
    };

    return {
        isBlocked,
        blockReason,
        reason,
        setBlocked,
        clearBlock,
    };
});
